// money.js — canonical money/copay formatting.
// SHARED SENTINEL: must remain byte-identical in orella-md-panel/src/utils/
// and orella-patient-app/src/utils/. Verify with md5sum after any change.
//
// Rule (v230.2.0): whole dollars render with no decimals ("\$55"); any cents
// render with exactly two decimals ("\$55.50"); unknown/invalid → null (callers
// fall back to an em dash). Applies to copay, deductible, and out-of-pocket so the
// same amount looks identical everywhere across the encounter cycle.

export function formatMoneyCents(cents) {
  if (cents === null || cents === undefined || typeof cents !== "number" || cents < 0) return null
  const dollars = cents / 100
  return Number.isInteger(dollars) ? `\$${dollars}` : `\$${dollars.toFixed(2)}`
}

export function formatMoneyDollars(value) {
  if (value === null || value === undefined || value === "") return null
  const n = typeof value === "number" ? value : Number(String(value).replace(/[^0-9.\-]/g, ""))
  if (!Number.isFinite(n) || n < 0) return null
  return Number.isInteger(n) ? `\$${n}` : `\$${n.toFixed(2)}`
}

